export class StateInfo
{
  Id: number
  StateCode: string
  StateName: string
  CycleCode: string
  FlagDelete: string
  CreateBy: string
  CreateByDisplay: string
  CreateDate: string
  UpdateBy: string
  UpdateByDisplay: string
  UpdateDate: string
}
